module.exports = __webpack_public_path__ + "static/media/chat02.437f1793.gif";